<app-badge badgeType="primary" *ngIf="count > 1 || count == 0">
	{{count}} {{pluralName}}
</app-badge>
<app-badge badgeType="primary" *ngIf="count == 1">
	{{count}} {{singularName}}
</app-badge>